import { queryClient } from './query-client';
import type { InvalidateOptions, InvalidateQueryFilters } from '@tanstack/react-query';

export const createSafeInvalidateQueries = <TPageData = unknown>(
  filters?: InvalidateQueryFilters<TPageData>,
) => {
  const reasonCache = new Set<string>();

  return (reasons?: string[], options?: InvalidateOptions) => {
    if (Array.isArray(reasons)) {
      const untrackedReasons = reasons.filter((item) => !reasonCache.has(item));

      if (untrackedReasons.length) {
        untrackedReasons.forEach((item) => reasonCache.add(item));

        return queryClient.invalidateQueries(filters, options);
      }

      return;
    }

    return queryClient.invalidateQueries(filters, options);
  };
};
